var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_html.js
// module id = 59
// module chunks = 0